import React from "react";
import { IntlProvider } from "react-intl";
import jaMessages from "./locales/ja.json";
import Layout from "./pages/Layout";
import AppRoutes from "./AppRoutes";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "./store/store";
import { fetchUser } from "./reducers/authSlice";
import { useScrollToTop } from "./common/hooks/useScrollToTop";

const messages = {
  ja: jaMessages,
};

const App: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { userData } = useSelector((state: RootState) => state.auth);

  if (!userData && sessionStorage.getItem("access_token")) {
    dispatch(fetchUser());
  }

  useScrollToTop();

  return (
    <IntlProvider locale={"ja"} messages={messages["ja"]}>
      {userData ? <Layout /> : <AppRoutes />}
    </IntlProvider>
  );
};

export default App;
